import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-store-offline-W9S',
  templateUrl: './store-offline-W9S.component.html',
  styleUrls: ['./store-offline-W9S.component.css']
})
export class StoreOfflineW9SComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
